import { bindable, autoinject, bindingMode } from 'aurelia-framework';
import * as moment from 'moment';
import numeral from 'numeral';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { Account } from '../../models/customer';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { Portfolio } from '../../models/portfolio';

@autoinject
export class PlanSummary {
	@bindable account: Account;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) plan;
	paymentDateSettings: any;
	paymentMethod: any;
	plannedPayments: Array<any>;
	nextPaymentDate: string;
	planEndDate: string;
	hasServiceFee = false;
	isLoading = true;
	isIndefinite = false;
	isMapp = false;
	planCustomerAccounts: string;

	// These may be needed over the account adjusted balances
	recurringPaymentAmount: number;
	amountPaidToDate: number;
	recurringPayment: number;

	constructor(private state: State, private payrazrService: PayrazrService, private router: Router, private i18n: I18N) {
	}

	attached() {
		this.paymentDateSettings = this.state.business.portalSettings.fields.paymentDate;
		if (!!this.paymentDateSettings && !this.paymentDateSettings.label) { this.paymentDateSettings.label = this.i18n.i18next.t('paymentDate', 'Payment Date'); }

		this.payrazrService.getPaymentPlanByCustomerAccountId(this.account.id)
			.then(result => {
				this.plan = result;
				this.isMapp = this.plan.isCombinedCustomerAccount;
				this.planCustomerAccounts = this.plan.customerAccounts;
				this.recurringPaymentAmount = result.recurringPaymentAmount;
				this.amountPaidToDate = result.amountPaidToDate;
				if (result.endDate) {
					this.planEndDate = moment(result.endDate).format('MM/DD/YYYY');
					this.isIndefinite = false;
				} else {
					this.planEndDate = 'Indefinite';
					this.isIndefinite = true;
				}
				this.paymentMethod = result.paymentMethod;

				// Get list of payments
				this.payrazrService.getLatestActivePaymentPlanPlannedPaymentsByCustomerAccountId(this.account.id)
					.then(results => {
						this.plannedPayments = results.plannedPayments;
						this.paymentMethod = results.paymentMethod;
						this.getFeeStatus();
						this.getNextPaymentDate();
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.showError('');
					});
			})
			.catch(error => {
				this.amountPaidToDate = 0;
				this.nextPaymentDate = '';
				this.planEndDate = '';
				this.paymentMethod = '';
				this.isLoading = false;
			});
	}

	getNextPaymentDate() {
		if (this.plannedPayments && this.plannedPayments.length) {
			let nextPayment = this.plannedPayments.find(p => p.status === 0 || p.status === 1);
			this.nextPaymentDate = nextPayment ? moment(nextPayment.billDate).format('MM/DD/YYYY') : 'N/A';
		} else {
			this.nextPaymentDate = 'N/A';
		}
	}

	getFeeStatus() {
		if (this.plannedPayments && this.plannedPayments.length >= 1) {
			const paymentsWithFees = this.plannedPayments.find(payment => payment.planedServiceFee > 0);
			this.hasServiceFee = paymentsWithFees ? true : false;
		}

	}

	parseStatusToText(status) {
		if (status === 0 || status === 1) {
			return this.i18n.i18next.t('scheduled', 'Scheduled');
		}
		if (status === 2 || status === 3 || status === 4) {
			return this.i18n.i18next.t('cancelled', 'Cancelled');
		}
		if (status === 5) {
			if (this.paymentMethod.includes('card')) {
				return this.i18n.i18next.t('approved', 'Approved');
			} else {
				return this.i18n.i18next.t('submitted', 'Submitted');
			}
		}
		return this.i18n.i18next.t('unknown', 'Unknown');

	}

	activate(params) {
		this.account = this.state.accounts.find((element, index, array) => {
			return element.id === params.id;
		});
		this.state.business.applyPortfolioSettingsToPortal(this.account.portfolioName, false);
	}

	showError(message: string) {
		alert(message); // TODO: Use something other than alerts
	}

}
